<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formSubrentalEntry">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center align-items-end">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-end">
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>

              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteSubrentalEntry()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewSubrentalEntry()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="subrentalEntryContract.userNameCreate"
                [createDate]="subrentalEntryContract.createDate"
                [userNameUpdate]="subrentalEntryContract.userNameUpdate"
                [updateDate]="subrentalEntryContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>

          <!-- Formulario Captura -->
          <div class="row d-flex justify-content-between">
            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
              <div class="row">
                <div class="col-lg-4 col-md-8 col-sm-6 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                    [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event, true)"></app-custom-select>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-3 col-4">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-3 col-4">
                  <app-custom-datepicker formControlName="dateEntry" [labelText]="'Fecha'"
                    [required]="true"></app-custom-datepicker>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-3 col-4">
                  <app-custom-input-text formControlName="remission" [labelText]="'Remisión'" [maxLength]="15">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-9 col-12">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                    [autoResize]="false" [maxLength]="250"></app-custom-textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-12 ps-lg-5 ps-md-2 pt-md-0 pt-sm-2">
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-3 col-6">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-2 d-flex align-items-end justify-content-center">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                </div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
                  <app-custom-button [disabled]="disabledForm" [label]="'Guardar'" [severity]="'primary'"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-subrental-entry-detail [disabledDetail]="disabledDetail" [subrentalEntryModel]="subrentalEntryContract"
      [quantityDetails]="quantityDetails" [disabledActions]="disabledActions" [listBranches]="listBranches"
      [permissionUpdatable]="permissionUpdatable" [permissionsUser]="permissionsUser"
      [userAuthenticated]="userAuthenticated" (emitQuantityDetails)="quantityDetails = $event">
    </app-subrental-entry-detail>
  </div>
</section>
<app-print-subrental-entry id="print-subrental-entry" [companyId]="companyId" [formatModel]="formatModel"
  [subrentalEntryModel]="subrentalEntryPrintModel" [editFormat]="false" [focusText]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-subrental-entry>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>
    No se permite tener dos ventanas/pestañas de {{ nameWindow }} abiertas.
  </h6>
</div>